module.exports = __webpack_public_path__ + "static/media/TOR_LOGO_430_2965.36eea09e.png";